(function () {
  function activateEmbed(container) {
    if (container.dataset.loaded === 'true') return;
    var videoId = container.dataset.youtubeId;
    if (!videoId) return;

    container.dataset.loaded = 'true';
    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube.com/embed/' +
      encodeURIComponent(videoId) +
      '?autoplay=1&rel=0';
    iframe.title = container.dataset.title || 'YouTube video';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.loading = 'lazy';
    container.replaceChildren(iframe);
  }

  function initContainer(container) {
    var button = container.querySelector('.js-lazy-youtube-play');
    if (button) {
      button.addEventListener('click', function () {
        activateEmbed(container);
      });
    }

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          if (entry.target.dataset.autoload === 'true') {
            activateEmbed(entry.target);
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    observer.observe(container);
  }

  function init() {
    document.querySelectorAll('[data-youtube-id]').forEach(initContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
